import React from "react";
import { Control } from "react-hook-form";
import { Grid } from "@mui/material";
import { Forms } from "@/types/form";
import constant from "@/utils/constant";
import { HelpIcon, Input } from "@dippi/ui";

interface Props {
    control: Control<Forms["Settings"]>;
}

const Contact: React.FC<Props> = ({ control }) => {
    return (
        <Grid item container xs={12} gap={constant.GRID_SPACING}>
            <Grid item xl={3} md={5} sm={5} xs={12}>
                <Input
                    testId="settings-phone-input"
                    name="phone"
                    control={control}
                    label="Mobile number"
                    type="tel"
                />
            </Grid>
            <Grid item xl={3} md={5} sm={5} xs={12}>
                <Input
                    name="email"
                    control={control}
                    type="email"
                    label="Organization email"
                    testId="settings-email-input"
                    InputProps={{
                        endAdornment: (
                            <HelpIcon
                                key="organization-email-help"
                                title="Organization email will be used for invoicing purposes."
                            />
                        ),
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default Contact;
